import Embed from "@pathwright/ui/src/components/embed/Embed"
import Text from "lib/core/components/text/Text"
import PropTypes from "prop-types"

const Reading = function ({ content, step }, context) {
  const {
    method,
    reading_text,
    listed_instructions,
    content_embed_code,
    reading_embed_code,
    embed_code
  } = content

  const embed = content_embed_code || reading_embed_code || embed_code

  return (
    <div className="Content__Reading Content--padded">
      {(() => {
        switch (method) {
          case "rt":
            return (
              <Text
                html={reading_text}
                templateContext={context}
                interceptLink={true}
                theme={true}
                latex={true}
              />
            )
          case "listed":
            return (
              <Text
                html={listed_instructions}
                templateContext={context}
                interceptLink={true}
                theme={true}
                latex={true}
              />
            )
          case "embed":
            return <Embed code={embed} executeScripts={true} />
        }
      })()}
    </div>
  )
}

Reading.contextTypes = {
  school: PropTypes.object,
  user: PropTypes.object
}

Reading.displayName = "Reading"

export default Reading
